module.exports = __webpack_public_path__ + "img/UTFRON-7.583d1a7d.jpg";